import { createContext } from "react";

export const FormLabelForContext = createContext("");
